import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { query, state } from 'lit/decorators.js';
import '../../elements/toast';
import { withConfig } from '@amityeko/pbc-core/dist/providers/configuration/consumer-mixin';
/**
 * This provider intercepts all the notifiaction related event and shows the required notification.
 *
 * Catches this events:
 * @event amityeko-notification--toast { message, variant }
 */
export default class AmityekoNotificationProvider extends withConfig(LitElement) {
    constructor() {
        super(...arguments);
        this.toastVariant = 'info';
    }
    _showToast(e) {
        e.stopPropagation();
        // If config even exist, then we check value. By default it is enabled.
        if (this.config) {
            if (!this.config.toast.enable)
                return;
        }
        const { message, variant } = e.detail || {};
        if (!message)
            return;
        this.toastMessage = message;
        this.toastVariant = variant;
        this.toast.show();
    }
    render() {
        return html `
      <slot @amityeko-notification--toast=${this._showToast}></slot>
      <amityeko-toast
        id="provider_toast"
        .variant=${this.toastVariant}
        .message=${this.toastMessage}
        .duration=${5000}
      ></amityeko-toast>
    `;
    }
}
__decorate([
    query('#provider_toast')
], AmityekoNotificationProvider.prototype, "toast", void 0);
__decorate([
    state()
], AmityekoNotificationProvider.prototype, "toastMessage", void 0);
__decorate([
    state()
], AmityekoNotificationProvider.prototype, "toastVariant", void 0);
if (!customElements.get('amityeko-notification-provider')) {
    customElements.define('amityeko-notification-provider', AmityekoNotificationProvider);
}
//# sourceMappingURL=index.js.map